import axios from 'axios'
import { Message } from 'element-ui'
import router from '@/router'
import config from '@/config/app-config'

// 创建axios实例
const service = axios.create({
  baseURL: config.api.baseURL, // 从配置中读取API基础URL
  timeout: config.api.timeout // 从配置中读取超时时间
})

// 添加环境标识到console
console.log(`[${config.isDevelopment ? 'Development' : 'Production'}] API服务地址: ${config.api.baseURL}`)

// 请求拦截器
service.interceptors.request.use(
  config => {
    // 从localStorage获取token，如果有则添加到请求头
    const token = localStorage.getItem('token')
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token
    }

    // // 添加调试日志，记录请求信息
    // console.log('【HTTP请求】', {
    //   url: config.url,
    //   method: config.method,
    //   headers: config.headers,
    //   data: config.data,
    //   params: config.params
    // });

    return config
  },
  error => {
    console.error('【HTTP请求错误】', error)
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    // // 添加调试日志，记录响应信息
    // console.log('【HTTP响应】', {
    //   status: response.status,
    //   statusText: response.statusText,
    //   headers: response.headers,
    //   data: response.data
    // });

    // 直接返回数据部分
    if (response.data) {
      return response.data
    }
    return response
  },
  error => {
    // 处理HTTP错误
    let message = '浏览器网络有波动，请稍后再试'
    
    console.error('【HTTP响应错误】', {
      status: error.response?.status,
      statusText: error.response?.statusText,
      data: error.response?.data,
      error: error.message
    });
    
    if (error.response) {
      const status = error.response.status
      
      // 处理不同的HTTP状态码
      if (status === 401) {
        message = '未授权，请重新登录'
        // 清除token并跳转到登录页面
        localStorage.removeItem('token')
        localStorage.removeItem('username')
        router.push('/login')
      } else if (status === 403) {
        message = '拒绝访问'
      } else if (status === 404) {
        message = '请求的资源不存在'
      } else if (status === 500) {
        message = '浏览器网络有波动，请稍后再试'
      }
      
      // 如果响应中包含错误信息，则优先使用
      if (error.response.data && error.response.data.message) {
        message = error.response.data.message
      }
    }
    
    // 显示错误消息
    Message({
      message: message,
      type: 'error',
      duration: 5 * 1000
    })
    
    return Promise.reject(error)
  }
)

export default service 